import Http from "../../../../../core/http-axios-react/http/Http";
import { HttpBaseRequest } from "../../../../../core/HttpRequest";
import { HttpBaseResponse, HttpData } from "../../../../../core/HttpResponse";
import { Form_Create_Retur } from "../../../form/retur/FormRetur";
import { M_Retur, M_ReturDetail } from "../../../type/Invoice.type";
export interface HTTP_Request_Retur extends HttpBaseRequest {
  start_date?: string;
  end_date?: string;
}

export const createRetur = async ({
  description,
  invoice_id,
  payment_method_id,
  product_list,
  return_invoice_date,
}: Form_Create_Retur) => {
  const results = await Http.post({
    url: "/invoice/return/insert",
    data: {
      description,
      invoice_id,
      payment_method_id,
      product_list,
      return_invoice_date,
    },
  });
  return results;
};

export const getRetur = async ({
  end_date,
  keyword,
  page,
  perPage,
  start_date,
}: HTTP_Request_Retur) => {
  const results = await Http.get<HttpBaseResponse<HttpData<M_Retur[]>>>({
    url: "/invoice/return",
    params: {
      start_date,
      end_date,
      keyword,
      page,
      perPage,
    },
  });
  return results;
};

export const getReturDetail = async ({
  return_invoice_id,
}: {
  return_invoice_id?: string;
}) => {
  const results = await Http.get<HttpBaseResponse<M_ReturDetail>>({
    url: "/invoice/return/detail",
    params: {
      return_invoice_id,
    },
  });
  return results;
};
